import { render, staticRenderFns } from "./DraftDAList.vue?vue&type=template&id=1323c056"
import script from "./DraftDAList.vue?vue&type=script&lang=js"
export * from "./DraftDAList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports